import { useState, useEffect, useCallback } from 'react'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { getDataMapFromCommonResponse, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'

export const useFollowupChecklist = (actionTrack, enabled = true) => {
  const [checklist, setChecklist] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchChecklist = useCallback(async () => {
    if (!enabled) {
      setChecklist(null)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const params = actionTrack ? { actionTrack } : {}

      const response = await getSPDataWithParams('/api/secure/cc/support/followups/checklist', params)

      if (response.status === 200 && isCommonResponseSuccessfulV2(response)) {
        const data = getDataMapFromCommonResponse(response)?.['support-followup-checklist']
        setChecklist(data)
      } else {
        setError('Failed to fetch checklist')
        setChecklist(null)
      }
    } catch (err) {
      console.error('Error fetching checklist:', err)
      setError('An error occurred while fetching checklist')
      setChecklist(null)
    } finally {
      setLoading(false)
    }
  }, [actionTrack, enabled])

  useEffect(() => {
    fetchChecklist()
  }, [fetchChecklist])

  return {
    checklist,
    loading,
    error,
    refreshChecklist: fetchChecklist,
  }
}


